import instance from "./axios.base";

const getInsurCompanies = async () => {
  const res = await instance.get("/typeinsure/company");
  return res.data;
};

export { getInsurCompanies };
